<template>
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <!-- 每个层级分开 -->
            <ul class="content" v-if="dataList.showStyle == '1'">
                <el-select
                    style="margin-right: 20px"
                    v-for="(column, index) in columns"
                    v-model="valueObj[`${index + 1}`]"
                    value-key="value"
                    @change="changePreSelect($event, index + 1)"
                    class="m-2"
                    :placeholder="`请选择${cityPlace[index]}`"
                    size="large"
                >
                    <el-option v-for="item in selectList[index + 1 + '']" :key="item.value" :label="item.label" :value="item" />
                </el-select>
                <div v-if="dataList.addressFormat == '4'" style="width: 100%; margin-top: 20px">
                    <el-input style="width: 706px" v-model="cityDetail" placeholder="详细地址" size="large"></el-input>
                </div>
            </ul>

            <!-- 一个选择框 -->
            <ul class="content" v-else>
                <el-cascader v-model="valueList" :options="dataList.optionsList" @change="handleChange" placeholder="请选择" size="large" />
                <div v-if="dataList.addressFormat == '4' && valueList.length > 0" style="width: 100%; margin-top: 20px">
                    <el-input style="width: 706px" v-model="cityDetail" placeholder="详细地址" size="large"></el-input>
                </div>
            </ul>
            <!-- 底部操作栏 -->
            <div class="footer-operation" v-if="footerShow">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                >
                </action-bar>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-city">
// js
import { ref, watch, computed } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
// 复制题目，删除题目, 数据改变, 单题预览, 标题修改后
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);
const cityPlace = ["省份", "城市", "地区"];
const titileInput = ref(null); // 为了标题聚焦使用
let selectList = ref({});
let valueObj = ref({}); // 虚拟绑定值
let valueList = ref([]);
let cityDetail = ref("");
selectList.value["1"] = JSON.parse(JSON.stringify(props.dataList.optionsList));

let columns = computed(() => {
    return +props.dataList.addressFormat > 3 ? 3 : +props.dataList.addressFormat;
});
watch(
    () => props.dataList,
    (curr, old) => {
        // 绑定数据改变时调change方法
        emits("change", curr);
    },
    { deep: true }
);

defineExpose({ titileInput });

// 展示当前下拉框
function changePreSelect(e, index) {
    if (e.children) {
        selectList.value[index + 1 + ""] = JSON.parse(JSON.stringify(e.children));
    }
}
function handleChange(e) {}
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

:deep(.el-select--large) {
    height: 34px;
}
.question-item {
    .content {
        display: flex;
        flex-wrap: wrap;
    }
    .footer-operation {
        .bottom-operation {
            display: flex;
            justify-content: space-between;
            color: rgba(34, 64, 195, 1);
            font-size: 13px;
            .button1 {
                cursor: pointer;
                &:nth-child(2) {
                    margin: 0 30px;
                }
                .icon {
                    margin-right: 7px;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
